(function () {
  'use strict';

  let activeBundleConfig = null;
  let isAddingBundle = false;
  let popupTimer = null;
  let lastTriggeredVariant = null;
  let lastTriggeredAt = 0;


  /*
  ============================================================
  UPSELL CONFIGS
  ============================================================
  */

  const bundleConfigs = [

    /*
    ============================================================
    FORÅRSRULLER - 69,-
    ============================================================
    */

    {
      triggerVariantIds: [
        42876000403704,
        57946997358974,
        57697274036606,
        47466684383572,
        56016976544126,
        55391328305534,
        43540047397112,
        57438175887742,
        57824711344510,
        57912848384382,
        56989210968446,
        50702095188308,
        56985543737726,
        57949452566910,
        57075577749886,
        57383689847166,
        49720506384724,
        56418634793342,
        56147350389118,
        57920906822014,
        57702044270974,
        56858104889726,
        57424592798078,
        43257487130872,
        57072533766526,
        50532933927252,
        57772860309886,
        47633405542740,
        47809422721364,
        57824714752382,
        57065668510078,
        49460772503892,
        57280737018238,
        57945351094654
      ],

      offerItems: [
        {
          id: 57959333855614,
          quantity: 1
        }
      ],

      popupPriceText: 'SPAR 30%',

      offerTitle:
        'Køb Kyllinge forårsruller',

      offerText:
        'Tilføj 12 stk forårsruller til din ordre for kun 69,-.',

      image1:
        'https://cdn.shopify.com/s/files/1/0529/0072/4908/files/6e9e2cb2-7dcc-48e5-81cf-6e858750f0e4.png?v=1781680872',

      image2: ''
    },


    /*
    ============================================================
    PAKKELØSNING - SPAR 20%
    ============================================================
    */

    {
      triggerVariantIds: [
        56096086622590,
        56696328585598,
        56624457646462,
        57153991180670,
        57075915358590,
        56382010425726,
        55435323375998,
        55495171113342
      ],

      offerItems: [
        {
          id: 57241769214334,
          quantity: 1
        }
      ],

      popupPriceText: '',

      offerTitle:
        'Spar 20% på denne pakkeløsning!',

      offerText:
        'Tilføj denne pakkeløsning til din ordre med ét klik.',

      image1:
        'https://cdn.shopify.com/s/files/1/0529/0072/4908/files/image_4e6bc231-1bbc-460b-aedd-ca8397e2ce03.jpg?v=1776071240',

      image2:
        'https://cdn.shopify.com/s/files/1/0529/0072/4908/files/1a_e8575bc3-2cea-458f-8e3c-d07b53745977-203708_1.jpg?v=1776071215'
    },


    /*
    ============================================================
    BBQ SAUCE - 5 STK / 75,-
    ============================================================
    */

    {
      triggerVariantIds: [
        57262938980734,
        55587046097278,
        57867526504830,
        57947721007486
      ],

      offerItems: [
        {
          id: 57291427381630,
          quantity: 1
        }
      ],

      popupPriceText:
        'Kun 75,- | Spar 40% pr. stk',

      offerTitle:
        'Køb 5 BBQ sauce med',

      offerText:
        'Tilføj 5 stk BBQ sauce til din ordre og spar 40% pr. stk.',

      image1:
        'https://cdn.shopify.com/s/files/1/0529/0072/4908/files/0255E5C5-3C7B-40DD-B2CC-8B1C2CE29EB2_1051d041-e6ea-4ee4-977f-1bfeca04846b.jpg?v=1776411809',

      image2: ''
    }

  ];


  /*
  ============================================================
  HENT POPUP ELEMENTER
  ============================================================
  */

  function getPopupElements() {

    const popup =
      document.getElementById(
        'kr-bundle-popup'
      );

    if (!popup) {
      return null;
    }

    return {

      popup: popup,

      overlay:
        popup.querySelector(
          '.kr-bundle-popup__overlay'
        ),

      closeBtn:
        popup.querySelector(
          '.kr-bundle-popup__close'
        ),

      declineBtn:
        document.getElementById(
          'kr-bundle-decline'
        ),

      addBtn:
        document.getElementById(
          'kr-bundle-add'
        ),

      priceEl:
        document.getElementById(
          'kr-bundle-price'
        ),

      titleEl:
        document.getElementById(
          'kr-bundle-offer-title'
        ),

      textEl:
        document.getElementById(
          'kr-bundle-offer-text'
        ),

      img1:
        document.getElementById(
          'kr-bundle-image-1'
        ),

      img2:
        document.getElementById(
          'kr-bundle-image-2'
        )

    };
  }


  /*
  ============================================================
  FIND MATCHENDE UPSELL
  ============================================================
  */

  function getMatchingBundleConfig(variantId) {

    const numericVariantId =
      Number(variantId);

    if (!numericVariantId) {
      return null;
    }

    return (
      bundleConfigs.find(
        function (config) {

          return config
            .triggerVariantIds
            .includes(
              numericVariantId
            );

        }
      ) || null
    );
  }


  /*
  ============================================================
  RESET TILFØJ-KNAP
  ============================================================
  */

  function resetAddButton() {

    const addBtn =
      document.getElementById(
        'kr-bundle-add'
      );

    if (!addBtn) {
      return;
    }

    addBtn.classList.remove(
      'is-loading'
    );

    addBtn.disabled =
      false;

    addBtn.textContent =
      'Tilføj tilbud';
  }


  /*
  ============================================================
  FYLD POPUP MED AKTUELT TILBUD
  ============================================================
  */

  function hydratePopup(config) {

    const elements =
      getPopupElements();

    if (!elements) {

      console.error(
        '[KØDRIGET UPSELL] Popup HTML findes ikke på siden.'
      );

      return false;
    }


    resetAddButton();


    /*
    PRIS
    */

    if (elements.priceEl) {

      elements.priceEl.textContent =
        config.popupPriceText || '';

      elements.priceEl.style.display =
        config.popupPriceText
          ? ''
          : 'none';
    }


    /*
    OVERSKRIFT
    */

    if (elements.titleEl) {

      elements.titleEl.textContent =
        config.offerTitle || '';

    }


    /*
    BESKRIVELSE
    */

    if (elements.textEl) {

      elements.textEl.textContent =
        config.offerText || '';

    }


    /*
    BILLEDE 1
    */

    if (elements.img1) {

      if (config.image1) {

        elements.img1.src =
          config.image1;

        elements.img1.alt =
          config.offerTitle || '';

        elements.img1.style.display =
          'block';

      } else {

        elements.img1.removeAttribute(
          'src'
        );

        elements.img1.style.display =
          'none';

      }
    }


    /*
    BILLEDE 2
    */

    if (elements.img2) {

      if (config.image2) {

        elements.img2.src =
          config.image2;

        elements.img2.alt =
          config.offerTitle || '';

        elements.img2.style.display =
          'block';

      } else {

        elements.img2.removeAttribute(
          'src'
        );

        elements.img2.style.display =
          'none';

      }
    }


    return true;
  }


  /*
  ============================================================
  ÅBN POPUP
  ============================================================
  */

  function openPopup() {

    const elements =
      getPopupElements();

    if (!elements) {

      console.error(
        '[KØDRIGET UPSELL] Kan ikke åbne popup - #kr-bundle-popup mangler.'
      );

      return;
    }


    resetAddButton();


    elements.popup.hidden =
      false;


    /*
    Gem tidligere overflow
    */

    if (
      typeof document.body.dataset
        .krPreviousOverflow ===
      'undefined'
    ) {

      document.body.dataset
        .krPreviousOverflow =
        document.body.style.overflow || '';

    }


    /*
    Lås scroll
    */

    document.body.style.overflow =
      'hidden';


    console.log(
      '[KØDRIGET UPSELL] Popup åbnet'
    );
  }


  /*
  ============================================================
  LUK POPUP
  ============================================================
  */

  function closePopup() {

    const elements =
      getPopupElements();


    if (popupTimer) {

      clearTimeout(
        popupTimer
      );

      popupTimer =
        null;
    }


    if (elements) {

      elements.popup.hidden =
        true;

    }


    /*
    Gendan scroll
    */

    document.body.style.overflow =
      document.body.dataset
        .krPreviousOverflow || '';


    delete document.body.dataset
      .krPreviousOverflow;


    /*
    Nulstil aktiv config
    */

    activeBundleConfig =
      null;


    resetAddButton();
  }


  /*
  ============================================================
  CHECK OM VARIANT SKAL TRIGGE UPSELL
  ============================================================
  */

  function maybeShowPopup(variantId) {

    if (isAddingBundle) {
      return;
    }


    const numericVariantId =
      Number(variantId);


    if (!numericVariantId) {
      return;
    }


    console.log(
      '[KØDRIGET UPSELL] Variant registreret:',
      numericVariantId
    );


    const matchingConfig =
      getMatchingBundleConfig(
        numericVariantId
      );


    /*
    Ingen upsell på varianten
    */

    if (!matchingConfig) {

      console.log(
        '[KØDRIGET UPSELL] Variant har ingen upsell:',
        numericVariantId
      );

      return;
    }


    /*
    Undgå dobbelt-trigger fra
    variant:add + fallback
    */

    const now =
      Date.now();


    if (
      lastTriggeredVariant ===
        numericVariantId &&
      now - lastTriggeredAt < 1500
    ) {

      console.log(
        '[KØDRIGET UPSELL] Dobbelt-event ignoreret'
      );

      return;
    }


    lastTriggeredVariant =
      numericVariantId;

    lastTriggeredAt =
      now;


    console.log(
      '[KØDRIGET UPSELL] MATCH!',
      numericVariantId,
      matchingConfig.offerTitle
    );


    /*
    Sæt den korrekte upsell
    */

    activeBundleConfig =
      matchingConfig;


    /*
    Opdater popup
    */

    const hydrated =
      hydratePopup(
        activeBundleConfig
      );


    if (!hydrated) {
      return;
    }


    /*
    Ryd tidligere timer
    */

    if (popupTimer) {

      clearTimeout(
        popupTimer
      );

    }


    /*
    Åbn popup efter kort delay
    */

    popupTimer =
      setTimeout(
        function () {

          openPopup();

          popupTimer =
            null;

        },
        350
      );
  }


  /*
  ============================================================
  TILFØJ UPSELL TIL KURV
  ============================================================
  */

  async function addBundleToCart(event) {

    if (event) {

      event.preventDefault();
      event.stopPropagation();

    }


    if (isAddingBundle) {
      return;
    }


    /*
    Gem den aktive config.
    På den måde kan den ikke skifte midt i requesten.
    */

    const currentConfig =
      activeBundleConfig;


    if (!currentConfig) {

      console.warn(
        '[KØDRIGET UPSELL] Ingen aktiv upsell-config'
      );

      return;
    }


    isAddingBundle =
      true;


    const elements =
      getPopupElements();


    try {


      /*
      Loading state
      */

      if (elements?.addBtn) {

        elements.addBtn.disabled =
          true;

        elements.addBtn.classList.add(
          'is-loading'
        );

        elements.addBtn.textContent =
          'Tilføjer...';

      }


      /*
      Shopify root
      */

      const root =
        window.Shopify?.routes?.root ||
        '/';


      /*
      Tilføj upsell til kurv
      */

      const response =
        await fetch(
          root + 'cart/add.js',
          {

            method:
              'POST',

            headers: {

              'Content-Type':
                'application/json',

              Accept:
                'application/json'

            },

            body:
              JSON.stringify({

                items:
                  currentConfig.offerItems

              })

          }
        );


      /*
      Parse Shopify response
      */

      let data =
        {};


      try {

        data =
          await response.json();

      } catch (e) {}


      /*
      Shopify fejl
      */

      if (!response.ok) {

        throw new Error(

          data.description ||
          data.message ||
          'Kunne ikke tilføje tilbuddet'

        );

      }


      /*
      Luk popup
      */

      closePopup();


      /*
      Opdater Impact cart drawer
      */

      document.documentElement
        .dispatchEvent(

          new CustomEvent(
            'cart:refresh',
            {

              bubbles:
                true

            }
          )

        );


      console.log(
        '[KØDRIGET UPSELL] Upsell tilføjet:',
        currentConfig.offerItems
      );


    } catch (error) {


      console.error(
        '[KØDRIGET UPSELL] FEJL:',
        error
      );


      /*
      Gør knappen aktiv igen
      */

      if (elements?.addBtn) {

        elements.addBtn.disabled =
          false;

        elements.addBtn.classList.remove(
          'is-loading'
        );

        elements.addBtn.textContent =
          'Prøv igen';

      }


    } finally {


      isAddingBundle =
        false;


    }
  }


  /*
  ============================================================
  POPUP KNAPPER
  ============================================================

  Capture = true.
  Dette hjælper med mobil-tap.
  ============================================================
  */

  document.addEventListener(
    'click',
    function (event) {


      /*
      TILFØJ TILBUD
      */

      const addButton =
        event.target.closest(
          '#kr-bundle-add'
        );


      if (addButton) {

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        addBundleToCart(
          event
        );

        return;
      }


      /*
      NEJ TAK
      */

      const declineButton =
        event.target.closest(
          '#kr-bundle-decline'
        );


      if (declineButton) {

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        closePopup();

        return;
      }


      /*
      X KNAP
      */

      const closeButton =
        event.target.closest(
          '.kr-bundle-popup__close'
        );


      if (closeButton) {

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        closePopup();

        return;
      }


      /*
      OVERLAY
      */

      const overlay =
        event.target.closest(
          '.kr-bundle-popup__overlay'
        );


      if (overlay) {

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        closePopup();

      }

    },
    true
  );


  /*
  ============================================================
  IMPACT VARIANT:ADD
  ============================================================

  Primær trigger.
  Vi reagerer kun på den variant kunden lige har tilføjet.
  ============================================================
  */

  document.addEventListener(
    'variant:add',
    function (event) {


      console.log(
        '[KØDRIGET UPSELL] variant:add modtaget',
        event.detail
      );


      if (isAddingBundle) {
        return;
      }


      const items =
        event.detail?.items;


      if (
        Array.isArray(items) &&
        items.length
      ) {


        items.forEach(
          function (item) {


            const variantId =
              item.variant_id ||
              item.variantId ||
              item.id;


            if (variantId) {

              maybeShowPopup(
                variantId
              );

            }

          }
        );

      }

    }
  );


  /*
  ============================================================
  FORM SUBMIT FALLBACK
  ============================================================

  Hvis Impact på et bestemt produkt ikke udsender variant:add,
  kan vi stadig fange varianten fra produktformularen.
  ============================================================
  */

  document.addEventListener(
    'submit',
    function (event) {


      const form =
        event.target;


      if (
        !(form instanceof HTMLFormElement)
      ) {
        return;
      }


      if (
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }


      /*
      Ignorer formularer inde i popup
      */

      const popup =
        document.getElementById(
          'kr-bundle-popup'
        );


      if (
        popup &&
        popup.contains(form)
      ) {
        return;
      }


      if (isAddingBundle) {
        return;
      }


      const formData =
        new FormData(
          form
        );


      const variantId =
        formData.get(
          'id'
        );


      console.log(
        '[KØDRIGET UPSELL] Form submit:',
        variantId
      );


      if (!variantId) {
        return;
      }


      setTimeout(
        function () {

          maybeShowPopup(
            variantId
          );

        },
        300
      );

    }
  );


  /*
  ============================================================
  ADD-TO-CART CLICK FALLBACK
  ============================================================
  */

  document.addEventListener(
    'click',
    function (event) {


      if (isAddingBundle) {
        return;
      }


      const button =
        event.target.closest(

          '[data-add-to-cart], .product-form__submit, button[name="add"]'

        );


      if (!button) {
        return;
      }


      /*
      Ignorer vores egen upsell-knap
      */

      if (
        button.id ===
        'kr-bundle-add'
      ) {
        return;
      }


      const form =
        button.closest(
          'form[action*="/cart/add"]'
        );


      if (!form) {
        return;
      }


      const formData =
        new FormData(
          form
        );


      const variantId =
        formData.get(
          'id'
        );


      console.log(
        '[KØDRIGET UPSELL] Add-to-cart click:',
        variantId
      );


      if (!variantId) {
        return;
      }


      setTimeout(
        function () {

          maybeShowPopup(
            variantId
          );

        },
        350
      );

    }
  );


  /*
  ============================================================
  ESC LUKKER POPUP
  ============================================================
  */

  document.addEventListener(
    'keydown',
    function (event) {


      if (
        event.key ===
        'Escape'
      ) {


        const elements =
          getPopupElements();


        if (
          elements &&
          !elements.popup.hidden
        ) {

          closePopup();

        }

      }

    }
  );


  /*
  ============================================================
  DEBUG
  ============================================================
  */

  console.log(
    '[KØDRIGET UPSELL] SCRIPT LOADED'
  );


  console.log(
    '[KØDRIGET UPSELL] Popup findes ved load:',
    !!document.getElementById(
      'kr-bundle-popup'
    )
  );


  console.log(
    '[KØDRIGET UPSELL] Antal upsells:',
    bundleConfigs.length
  );


  /*
  ============================================================
  SCROLL LOCK SAFETY
  ============================================================
  */

  window.addEventListener(
    'pagehide',
    function () {


      document.body.style.overflow =
        document.body.dataset
          .krPreviousOverflow || '';


      delete document.body.dataset
        .krPreviousOverflow;


    }
  );


})();